import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MainComponent } from './main/main.component';

import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { IconsModule } from '@progress/kendo-angular-icons';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import 'hammerjs';
import { SettingComponent } from './setting/setting.component';
// import { ToggleButtonComponent } from './toggle-button/toggle-button.component';
import { ToastrModule } from 'ngx-toastr';
import { HeaderComponent } from './header/header.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { DateInputsModule, TimePickerModule } from '@progress/kendo-angular-dateinputs';
import { LoaderComponent } from './loader/loader.component';
//import { DatePickerModule } from '@progress/kendo-angular-dateinputs';

import { GridModule } from '@progress/kendo-angular-grid';
import { MenuModule } from '@progress/kendo-angular-menu';
import { FooterComponent } from './footer/footer.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { AuthGuard } from '././service/auth.guard';
import {
  TokenInterceptor,
  tokenInterceptorProvider,
} from './service/token-interceptor.service';
import { ErrorLogComponent } from './error-log/error-log.component';
import { EditorModule } from '@progress/kendo-angular-editor';
import { FloatingLabelModule } from '@progress/kendo-angular-label';
import { LabelModule } from '@progress/kendo-angular-label';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DetailsGridComponent } from './details-grid/details-grid.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { TransactionComponent } from './transaction/transaction.component';
import { DatePipe } from '@angular/common';
import { LoginLogComponent } from './login-log/login-log.component';
import { ReportsComponent } from './reports/reports.component';

import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ReportsModule } from './reports/reports.module';
import { RegisterComponent } from './register/register.component';
import { ClientOfferComponent } from './client-offer/client-offer.component';
import { MatRadioModule } from '@angular/material/radio';
import { ClientDirectoryComponent } from './client-directory/client-directory.component';
import { CouponCodeComponent } from './coupon-code/coupon-code.component';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MapService } from './service/map.service';
import { PanelBarModule } from '@progress/kendo-angular-layout';
import { WhatsappMessagesComponent } from './whatsapp-messages/whatsapp-messages.component';
import { AdminCommonModule } from './common/common.module';
import { TicketsComponent } from './tickets/tickets.component';
@NgModule({ declarations: [
        AppComponent,
        LoaderComponent,
        LoginComponent,
        RegisterComponent,
        DashboardComponent,
        MainComponent,
        SettingComponent,
        // ToggleButtonComponent,
        HeaderComponent,
        FooterComponent,
        ErrorLogComponent,
        DetailsGridComponent,
        MaintenanceComponent,
        TransactionComponent,
        LoginLogComponent,
        ReportsComponent,
        ClientOfferComponent,
        ClientDirectoryComponent,
        CouponCodeComponent,
        WhatsappMessagesComponent,
        TicketsComponent
    ],
    bootstrap: [AppComponent], imports: [
        //CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        NgxPaginationModule,
        ButtonsModule,
        IconsModule,
        InputsModule,
        ChartsModule,
        DropDownsModule,
        GridModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatButtonToggleModule,
        MatInputModule,
        TimePickerModule,
        FloatingLabelModule,
        ToastrModule.forRoot({
            closeButton: true,
            timeOut: 4000,
            progressBar: false,
        }),
        MenuModule,
        DateInputsModule,
        MatDialogModule,
        MatSlideToggleModule,
        EditorModule,
        LabelModule,
        MatTooltipModule,
        ReportsModule,
        MatRadioModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatOptionModule,
        MatIconModule,
        MatButtonModule,
        MatCheckboxModule,
        PanelBarModule,
        AdminCommonModule], providers: [
        AuthGuard,
        TokenInterceptor,
        MapService,
        tokenInterceptorProvider,
        DatePipe,
        provideHttpClient(withInterceptorsFromDi()),
        /* Every <mat-form-field> app-wide always floats its label above the
           box (Material's own supported, well-tested positioning), instead
           of the default "label sits inside the box until focused/filled"
           behavior. This is what V2's inputs look like (label always visible
           above, separate from the box) — matches it using Material's real
           mechanism rather than CSS fighting its internal transform math,
           which kept producing overlap/clipping bugs (see .mat-mdc-form-field
           rules in styles.css, restyled to match this once labels are
           correctly, natively positioned). */
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'always' } },
    ] })
export class AppModule { }
